/** Debounces edits and prevents a slow, obsolete request replacing a newer result. */
export class EwsRefresh {
  private revision = 0;
  private timer?: ReturnType<typeof setTimeout>;
  private disposed = false;
  schedule(action: () => void, delay = 400) {
    this.revision++;
    clearTimeout(this.timer);
    this.timer = setTimeout(() => { if (!this.disposed) action(); }, delay);
  }
  begin(): number { clearTimeout(this.timer); return ++this.revision; }
  current(revision: number): boolean { return !this.disposed && revision === this.revision; }
  destroy() { this.disposed = true; this.revision++; clearTimeout(this.timer); }
}
